import { Component, Input, OnChanges } from "@angular/core";
import { IconName } from "app/shared/models/icon-name.type";
import { SvgWrapperComponent } from "app/shared/components/svg/svg-wrapper/svg-wrapper.component";
import { NgIf } from "@angular/common";

@Component({
  selector: "svg-avatar",
  templateUrl: "./svg-avatar.component.html",
  styleUrls: ["./svg-avatar.component.scss"],
  imports: [SvgWrapperComponent, NgIf],
})
export class SvgAvatarComponent implements OnChanges {
  // Note : displayName is undefined for numbers that are not created in contacts
  @Input() public displayName?: string;
  @Input() public iconColor: string = "icon-color";
  @Input() public bgColor: string = "svg-wrapper--bg";
  @Input() public iconName: IconName = "contact";
  @Input() public isAdmin: boolean = false;
  @Input() public wrapperSize: string = "medium";
  @Input() public buttonBorder: string = "";
  @Input() public forceShowIcon: boolean = false;
  @Input() public isInitialsHidden: boolean = false;
  @Input() public e2e: string;

  public initials: string = "";
  public isIconShown: boolean = true;

  public ngOnChanges(): void {
    this.loadIconView();
  }

  private loadIconView(): void {
    this.displayName = this.displayName?.trim();
    this.initials = "";
    this.isIconShown =
      !this.initials ||
      this.initials.trim() === "" ||
      this.forceShowIcon ||
      this.isInitialsHidden;
  }
}
